export default {
  GET_USERS (state, data) {
    state.users = data.data
  },
  GET_MORE_USERS(state, data) {
		var users_data = data.data
   
		for (var i = 0; i < users_data.length; i++) {
			state.all_users.push(users_data[i])
		}
	},
  GET_ALL_USERS (state, data) {
    state.all_users = data.data
  },
  GET_USER (state, data) {
    state.user = data
  },
  GET_DELETED_USERS (state, data) {
    state.deleted_users = data.data
  },
  GET_ALL_PUBLIC_USERS (state, data) {
    state.all_public_users = data.data
  },
   // Wallet Mutations
  GET_WALLET_BALANCE (state, data) {
    if (data.status === 'success') {
      state.wallet_balance_kes = data.data.wallet_balance_kes
      state.wallet_balance_usd = data.data.wallet_balance_usd
    }
  },

GET_WALLET_TRANSACTIONS(state, data) {
  if (data && data.status === 'success') {
    state.wallet_transactions = data.data
    state.wallet_transactions_page = 1
  }
},

GET_MORE_WALLET_TRANSACTIONS(state, data) {
  if (data && data.status === 'success') {
    state.wallet_transactions = [...state.wallet_transactions, ...data.data]
    state.wallet_transactions_page = state.wallet_transactions_page + 1
  }
},

GET_ALL_WALLET_TRANSACTIONS(state, data) {
  if (data && data.status === 'success') {
    state.wallet_transactions = data.data
    state.wallet_transactions_page = 0
  }
},

  GET_WALLET_TRANSACTION (state, data) {
    if (data.status === 'success') {
      state.current_transaction = data.data
    }
  },

  GET_BOOKING_WALLET_TRANSACTIONS (state, data) {
    if (data.status === 'success') {
      state.booking_transactions = data.data.transactions
    }
  },

  GET_USER_DEPOSITS (state, data) {
    if (data.status === 'success') {
      state.user_deposits = data.data.deposits
    }
  },

  RESET_WALLET_STATE (state) {
    state.wallet_balance_kes = 0
    state.wallet_balance_usd = 0
    state.wallet_transactions = []
    state.wallet_transactions_total = 0
    state.current_transaction = null
    state.booking_transactions = []
    state.user_deposits = []
  }
}
